<template>
  <div>
    <el-form
      ref="studentParticularForm"
      label-position="top"
      :model="studentParticular"
      label-width="80px"
    >
      <formTitle title="學生資料 Student Particulars"></formTitle>
      <el-row :gutter="20" type="flex">
        <el-col :xl="12" :xs="24">
          <el-form-item
            label="英文姓名 Name in English "
            prop="englishName"
            :rules="[{ required: true, message: '', trigger: 'change' },{ pattern: /^[A-Z -]+$/, message: '請輸入大寫字母', trigger: 'change' },]"
          >
            <el-input
              :disabled="isView"
     
              v-model="studentParticular.englishName"
            ></el-input>
          </el-form-item>
          <div class="form-item-text" style="font-style: italic">
            (Identical to Official Identity Document)
          </div>
        </el-col>
        <el-col :xl="12" :xs="24">
          <el-form-item
            label="中文姓名 Chinese Name"
          
          >
            <el-input
              :disabled="isView"
              v-model="studentParticular.chineseName"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" type="flex">
        <el-col :xl="12" :xs="24">
          <el-form-item
            label="性別  Gender"
            prop="gender"
            :rules="[{ required: true, message: '', trigger: 'change' }]"
          >
            <el-radio-group
              :disabled="isView"
              v-model="studentParticular.gender"
            >
              <el-radio :label="0">男 Male</el-radio>
              <el-radio :label="1">女 Female</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :xl="12" :xs="24">
          <el-form-item
            label="出生日期  Date of Birth"
            prop="dateOfBirth"
            :rules="[{ required: true, message: '', trigger: 'change' }]"
          >
            <el-date-picker
              :default-value="defaultTime"
              :picker-options="expireTimeOPtion"
              :disabled="isView"
              format="yyyy-MM-dd"
              type="date"
              placeholder="選擇日期 Select date"
              v-model="studentParticular.dateOfBirth"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" type="flex">
        <el-col :xl="12" :xs="24">
          <el-form-item
            label="出生地點 Place of Birth"
            prop="placeOfBirth"
            :rules="[{ required: true, message: '', trigger: 'change' }]"
          >
            <el-row :gutter="10" type="flex" align="middle">
              <el-col :span="12">
                <el-select
                  :disabled="isView"
                  v-model="studentParticular.placeOfBirth"
                  placeholder="Select date"
                >
                  <el-option
                    v-for="(item, index) in placeBirth"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             
              </el-col>
              <el-col v-if="studentParticular.placeOfBirth == '其他 Others'" :span="12">
                <el-input
                  :disabled="isView"
                  v-model="studentParticular.placeOfBirthInput"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :xl="12" :xs="24">
          <el-form-item
            label="國籍 Nationality"
            prop="nationality"
            :rules="[{ required: true, message: '', trigger: 'change' }]"
          >
               <el-row :gutter="10" type="flex" align="middle">
              <el-col :span="12">
                <el-select
                  :disabled="isView"
                  v-model="studentParticular.nationality"
                  placeholder=""
                >
                  <el-option
                    v-for="(item, index) in nationality"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col
                v-if="studentParticular.nationality == '其他 Others'"
                :span="12"
              >
                <el-input
                  :disabled="isView"
                  v-model="studentParticular.nationalityInput"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xl="12" :xs="24">
          <el-form-item
            label="家中主要使用語言 Spoken Language at Home"
            prop="spokenLanguageAtHome"
            :rules="[{ required: true, message: '', trigger: 'change' }]"
          > 
            <el-select :disabled="isView" v-model="studentParticular.spokenLanguageAtHome">
                <el-option v-for="(item,index) in parentLanguage" :key="index" :label="item" :value="item"></el-option>
            </el-select>
           
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item class="el-form-item__row" label="身份證明文件類別  Type of Identity Document">
        <el-radio-group
          :disabled="isView"
          v-model="studentParticular.typeOfIdentityDocument.type"
          class="document-identity-radio"
        >
          <el-radio :label="0">
            <el-row
              type="flex"
              align="middle"
              justify="space-between"
              class="passport-row"
              
            >
              <el-col :xl="9" :xs="24" class="wordWrap passport-row-label">
                <div class="wordWrap">
                  出生證明書/香港身份證 Birth Cert./Hong Kong ID card
                </div>
                證件號碼 Certificate No.
              </el-col>
              <el-col :xl="14" :xs="24">
                <el-row type="flex" align="middle">
                  <el-col :xl="2" :xs="8">
                    <el-form-item
                      prop="certificateNoTop"
                      :rules="[
                        {
                          required:
                            studentParticular.typeOfIdentityDocument.type == 0,
                          message: 'is required',
                          trigger: 'blur',
                        },
                        {
                          pattern: /^[A-Z]+$/,
                          message: '請輸入數字或大寫字母',
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input
                        :maxlength="1"
                        :disabled="
                          studentParticular.typeOfIdentityDocument.type == 1 ||
                          isView
                        "
                        v-model="studentParticular.certificateNoTop"
                        placeholder=""
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" style="text-align: center">-</el-col>
                  <el-col :xl="4" :xs="8">
                    <el-form-item
                      prop="certificateNoCont"
                      :rules="[
                        {
                          required:
                            studentParticular.typeOfIdentityDocument.type == 0,
                          message: 'is required',
                          trigger: 'blur',
                        },
                        {
                          pattern: /^[0-9]+$/,
                          message: '請輸入純數字',
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input
                        :maxlength="6"
                        :disabled="
                          studentParticular.typeOfIdentityDocument.type == 1 ||
                          isView
                        "
                        v-model="studentParticular.certificateNoCont"
                        placeholder=""
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xl="3" :xs="8">
                    <el-form-item
                      prop="certificateNoBottom"
                      :rules="[
                        {
                          required:
                            studentParticular.typeOfIdentityDocument.type == 0,
                          message: 'is required',
                          trigger: 'blur',
                        },
                        {
                          pattern: /^[0-9A-Z]+$/,
                          message: '請输入数字或大写字母',
                          trigger: 'blur',
                        },
                      ]"
                    >
                      (<el-input
                        :maxlength="1"
                        :disabled="
                          studentParticular.typeOfIdentityDocument.type == 1 ||
                          isView
                        "
                        v-model="studentParticular.certificateNoBottom"
                        placeholder=""
                      ></el-input
                      >)
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-radio>
          <el-radio :label="1">
            <div>護照 Passport</div>
            <el-row type="flex" class="passport-row" align="middle" :gutter="6">
              <el-col :xl="12" :xs="24">
                <el-row type="flex" align="middle">
                  <el-col :span="13" class="passport-row-label">
                    <span>證件號碼 Passport No.</span>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item
                      style="display: inline-block"
                      :prop="'typeOfIdentityDocument.passportNo'"
                      :rules="[
                        {
                          required:
                            studentParticular.typeOfIdentityDocument.type == 1,
                          message: 'is required',
                          trigger: 'blur',
                        },
                        {
                          pattern: /^[0-9A-Za-z]+$/,
                          message: '請输入数字或字母',
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input
                        :disabled="
                          studentParticular.typeOfIdentityDocument.type == 0||
                          isView
                        "
                        v-model="
                          studentParticular.typeOfIdentityDocument.passportNo
                        "
                        placeholder=""
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xl="12" :xs="24">
                <el-row type="flex"  align="middle">
                  <el-col :span="6" class="passport-row-label">
                    <span>國家 Country</span>
                  </el-col>
                  <el-col :span="18">
                    <el-form-item
                      style="display: inline-block"
                      :prop="'typeOfIdentityDocument.country'"
                      :rules="[
                        {
                          required:
                            studentParticular.typeOfIdentityDocument.type == 1,
                          message: 'is required',
                          trigger: 'blur',
                        },
                      ]"
                    >
                     <el-row :gutter="10" type="flex" align="middle">
                        <el-col :span="12">
                          <el-select
                            :disabled="
                              studentParticular.typeOfIdentityDocument.type ==
                                0 || isView
                            "
                            v-model="
                              studentParticular.typeOfIdentityDocument.country
                            "
                            placeholder=""
                          >
                            <el-option
                              v-for="(item, index) in nationality"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-col>
                        <el-col
                          v-if="studentParticular.typeOfIdentityDocument.country == '其他 Others'"
                          :span="12"
                        >
                          <el-input
                            :disabled="isView"
                            v-model="studentParticular.typeOfIdentityDocument.countryInput"
                          ></el-input>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :xl="12" :xs="24">
          <el-form-item
            label="種族 Ethnicity"
            prop="ethnicity"
            :rules="[{ required: true, message: '', trigger: 'change' }]"
          > 
            <el-select :disabled="isView" v-model="studentParticular.ethnicity">
                <el-option v-for="(item,index) in ethnicity" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xl="8" :xs="24">
          <el-form-item
            label="聯絡電話 Contact No."
            prop="contactNo"
            :rules="[
              { required: true, message: '', trigger: 'change' },
              {
                pattern: /^[0-9]+$/,
                message: '請輸入純數字',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              maxlength="8"
              :disabled="isView"
              v-model="studentParticular.contactNo"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="el-form-item__row el-form-item__row-en">居住住址(中文) Address</div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label=""
                :prop="'address.flat'"
                :rules="[{ required: false, message: '必須填寫室號', trigger: 'change' }]"
              >
                <el-input
                  :disabled="isView"
                  v-model="studentParticular.address.flat"
                  placeholder="室 Flat"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label=""
                :prop="'address.floor'"
                :rules="[{ required: false, message: '必須填寫樓層', trigger: 'change' }]"
              >
                <el-input
                  :disabled="isView"
                  v-model="studentParticular.address.floor"
                  placeholder="樓 Floor"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label=""
                :prop="'address.block'"
                :rules="[{ required: false, message: '必須填寫座號', trigger: 'change' }]"
              >
                <el-input
                  :disabled="isView"
                  v-model="studentParticular.address.block"
                  placeholder="座 Block"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label=""
            :prop="'address.building'"
            :rules="[{ required: false, message: '必須填寫大廈', trigger: 'change' }]"
          >
            <el-input
              :disabled="isView"
              v-model="studentParticular.address.building"
              placeholder="大廈 Building"
            ></el-input>
          </el-form-item>
          <el-form-item
            label=""
            :prop="'address.village'"
            :rules="[{ required: false, message: '必須填寫村/屋邨', trigger: 'change' }]"
          >
            <el-input
              :disabled="isView"
              v-model="studentParticular.address.village"
              placeholder="村/屋邨 Village / Estate"
            ></el-input>
          </el-form-item>
          <el-form-item
            label=""
            :prop="'address.street'"
            :rules="[{ required: false, message: '必須填寫街道名稱及號碼', trigger: 'change' }]"
          >
            <el-input
              :disabled="isView"
              v-model="studentParticular.address.street"
              placeholder="街道名稱及號碼 Street and No"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-row :gutter="10" type="flex">
            <el-col :xl="8" :xs="12">
              <el-form-item
                label=""
                :prop="'address.district'"
                :rules="[{ required: false, message: '必須填寫地區', trigger: 'change' }]"
              >
                <el-select
                  :disabled="isView"
                  v-model="studentParticular.address.district"
                  placeholder="- 地區 District -"
                >
                  <el-option
                    v-for="(item, index) in districtCn"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xl="8" :xs="12">
              <el-form-item
                label=""
                :prop="'address.area'"
                :rules="[{ required: false, message: '必須填寫區域', trigger: 'change' }]"
              >
                <el-select
                  :disabled="isView"
                  v-model="studentParticular.address.area"
                  placeholder="- 區域 Area -"
                >
                  <el-option
                    v-for="(item, index) in areaCn"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="el-form-item__row ">居住住址(英文) Address</div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label=""
                :prop="'addressEn.flat'"
                :rules="[{ required: true, message: '必須填寫室號', trigger: 'change' }]"
              >
                <el-input
                  :disabled="isView"
                  v-model="studentParticular.addressEn.flat"
                  placeholder="室 Flat"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label=""
                :prop="'addressEn.floor'"
                :rules="[{ required: true, message: '必須填寫樓層', trigger: 'change' }]"
              >
                <el-input
                  :disabled="isView"
                  v-model="studentParticular.addressEn.floor"
                  placeholder="樓 Floor"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label=""
                :prop="'addressEn.block'"
                :rules="[{ required: true, message: '必須填寫座號', trigger: 'change' }]"
              >
                <el-input
                  :disabled="isView"
                  v-model="studentParticular.addressEn.block"
                  placeholder="座 Block"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label=""
            :prop="'addressEn.building'"
            :rules="[{ required: true, message: '必須填寫大廈', trigger: 'change' }]"
          >
            <el-input
              :disabled="isView"
              v-model="studentParticular.addressEn.building"
              placeholder="大廈 Building"
            ></el-input>
          </el-form-item>
          <el-form-item
            label=""
            :prop="'addressEn.village'"
            :rules="[{ required: true, message: '必須填寫村/屋邨', trigger: 'change' }]"
          >
            <el-input
              :disabled="isView"
              v-model="studentParticular.addressEn.village"
              placeholder="村/屋邨 Village / Estate"
            ></el-input>
          </el-form-item>
          <el-form-item
            label=""
            :prop="'addressEn.street'"
            :rules="[{ required: true, message: '必須填寫街道名稱及號碼', trigger: 'change' }]"
          >
            <el-input
              :disabled="isView"
              v-model="studentParticular.addressEn.street"
              placeholder="街道名稱及號碼 Street and No"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-row :gutter="10" type="flex">
            <el-col :xl="8" :xs="12">
              <el-form-item
                label=""
                :prop="'addressEn.district'"
                :rules="[{ required: true, message: '必須填寫地區', trigger: 'change' }]"
              >
                <el-select
                  :disabled="isView"
                  v-model="studentParticular.addressEn.district"
                  placeholder="- 地區 District -"
                >
                  <el-option
                    v-for="(item, index) in districtEn"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xl="8" :xs="12">
              <el-form-item
                label=""
                :prop="'addressEn.area'"
                :rules="[{ required: true, message: '必須填寫區域', trigger: 'change' }]"
              >
                <el-select
                  :disabled="isView"
                  v-model="studentParticular.addressEn.area"
                  placeholder="- 區域 Area -"
                >
                  <el-option
                    v-for="(item, index) in areaEn"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="el-form-item__row-label">
            通訊地址(如與上述地址不同) Correspondence Address (if different from
            above)
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="">
                <el-input
                  :disabled="isView"
                  v-model="studentParticular.correspondenceAddress.flat"
                  placeholder="室 Flat"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="">
                <el-input
                  :disabled="isView"
                  v-model="studentParticular.correspondenceAddress.floor"
                  placeholder="樓 Floor"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="">
                <el-input
                  :disabled="isView"
                  v-model="studentParticular.correspondenceAddress.block"
                  placeholder="座 Block"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="">
            <el-input
              :disabled="isView"
              v-model="studentParticular.correspondenceAddress.building"
              placeholder="大廈 Building"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              :disabled="isView"
              v-model="studentParticular.correspondenceAddress.village"
              placeholder="村/屋邨 Village / Estate"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              :disabled="isView"
              v-model="studentParticular.correspondenceAddress.street"
              placeholder="街道名稱及號碼 Street and No"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-row :gutter="10" type="flex">
            <el-col :xl="8" :xs="12">
              <el-form-item label="">
                <el-select
                  :disabled="isView"
                  v-model="studentParticular.correspondenceAddress.district"
                  placeholder="- 地區 District -"
                >
                  <el-option
                    v-for="(item, index) in district"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xl="8" :xs="12">
              <el-form-item label="">
                <el-select
                  :disabled="isView"
                  v-model="studentParticular.correspondenceAddress.area"
                  placeholder="- 區域 Area -"
                >
                  <el-option
                    v-for="(item, index) in area"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xl="8" :xs="24">
          <el-form-item
            label="宗教 Religion"
            prop="religion"
            :rules="[{ required: true, message: '', trigger: 'change' }]"
          >
         <el-row :gutter="10" type="flex" align="middle">
              <el-col :span="6">
                <el-select
                  :disabled="isView"
                  v-model="studentParticular.religion"
                  placeholder=""
                >
                  <el-option
                    v-for="(item, index) in religion"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col
                v-if="studentParticular.religion == '其他 Others'"
                :span="6"
              >
                <el-input
                  :disabled="isView"
                  v-model="studentParticular.religionInput"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="是否新來港學童 New Arrival to HK?  ">
        <el-radio-group
          :disabled="isView"
          v-model="studentParticular.newArrivalToHk.isNew"
          class="document-identity-radio"
        >
          <el-radio :label="false">
            <div>不是 No</div>
          </el-radio>
          <el-radio :label="true">
            <div>是 Yes</div>
            <el-row type="flex" class="passport-row" align="middle" :gutter="6">
              <el-col :xl="12" :xs="24">
                <el-row type="flex" align="middle">
                  <el-col :xl="12" :xs="12" class="passport-row-label">原居地 Place of Origin</el-col>
                  <el-col :xl="12" :xs="12">
                    <el-form-item
                      :prop="'newArrivalToHk.placeOfOrign'"
                      :rules="[
                        {
                          required: studentParticular.newArrivalToHk.isNew,
                          message: 'is required',
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input
                        :disabled="
                          !studentParticular.newArrivalToHk.isNew || isView
                        "
                        v-model="studentParticular.newArrivalToHk.placeOfOrign"
                        placeholder=""
                      ></el-input> </el-form-item
                  ></el-col>
                </el-row>
              </el-col>
              <el-col :xl="12" :xs="24">
                <el-row type="flex" align="middle">
                  <el-col :xl="12" :xs="12" class="passport-row-label"> 來港日期 Arrival Date </el-col>
                  <el-col :xl="12" :xs="12">
                    <el-form-item
                      :prop="'newArrivalToHk.arrivalDate'"
                      :rules="[
                        {
                          required: studentParticular.newArrivalToHk.isNew,
                          message: 'is required',
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-date-picker
                        type="date"
                        :disabled="
                          !studentParticular.newArrivalToHk.isNew || isView
                        "
                        placeholder="選擇日期 Select date"
                        v-model="studentParticular.newArrivalToHk.arrivalDate"
                        style="width: 100%"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="申請入讀年級 Level Applying for"
        prop="levelApplyingFor"
        :rules="[{ required: true, message: '', trigger: 'change' }]"
      >
        <el-radio-group
          :disabled="isView"
          v-model="studentParticular.levelApplyingFor"
          class="document-identity-radio"
        >
          <el-radio :label="7"> 通階一 MS1 (中三 S3) </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="申請人有否曾申請或就讀真道書院? Has the applicant previously applied for or attended Logos Academy?	"
      >
        <el-radio-group
          :disabled="isView"
          v-model="studentParticular.applicantPreviouslyApplied.isHas"
          class="document-identity-radio"
        >
          <el-radio :label="false">
            <div>沒有 No</div>
          </el-radio>
          <el-radio :label="true">
            <div>有 Yes</div>
            <el-row type="flex" class="passport-row" align="middle" :gutter="6">
              <el-col :xl="12" :xs="24">
                <el-row type="flex" align="middle">
                  <el-col :xl="12" :xs="12" class="passport-row-label"> 申請/就讀級別 Level(s) </el-col>
                  <el-col :xl="12" :xs="12">
                    <el-form-item
                      :prop="'applicantPreviouslyApplied.level'"
                      :rules="[
                        {
                          required:
                            studentParticular.applicantPreviouslyApplied.isHas,
                          message: 'is required',
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input
                        :disabled="
                          !studentParticular.applicantPreviouslyApplied.isHas ||
                          isView
                        "
                        v-model="
                          studentParticular.applicantPreviouslyApplied.level
                        "
                        placeholder=""
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xl="12" :xs="24">
                <el-row type="flex" align="middle">
                  <el-col :xl="8" :xs="12" class="passport-row-label"> 年份 Year(s) </el-col>
                  <el-col :xl="8" :xs="12">
                    <el-form-item
                      :prop="'applicantPreviouslyApplied.year'"
                      :rules="[
                        {
                          required:
                            studentParticular.applicantPreviouslyApplied.isHas,
                          message: 'is required',
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input
                        :disabled="
                          !studentParticular.applicantPreviouslyApplied.isHas ||
                          isView
                        "
                        v-model="
                          studentParticular.applicantPreviouslyApplied.year
                        "
                        placeholder=""
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- <el-form-item label="現時在本校就讀之兄弟姊妹 Siblings at Logos Academy">
        <el-radio-group
          :disabled="isView"
          v-model="studentParticular.siblingsAtLogosAcademy.isHas"
          class="document-identity-radio"
        >
          <el-radio :label="false">
            <div>沒有 No</div>
          </el-radio>
          <el-radio :label="true">
            <div>有 Yes</div>
            <div v-for="(item, index) in studentParticular.siblingsAtLogosAcademy.siblings" :key="index">
            <el-row
              type="flex"
              class="logos-academy passport-row"
              align="middle"
              :gutter="6"
            >
              <el-col :xl="8" :xs="24">
                <el-row type="flex" align="middle">
                  <el-col :xl="8" :xs="12" class="passport-row-label"> 姓名 Name </el-col>
                  <el-col :xl="8" :xs="12">
                    <el-form-item label="" :prop="'siblingsAtLogosAcademy.siblings.'+index + '.name'" :rules="[{ required: studentParticular.siblingsAtLogosAcademy.isHas, message: '姓名未输入', trigger: 'change' }]">
                    <el-input
                      :disabled="
                        !studentParticular.siblingsAtLogosAcademy.isHas ||
                        isView
                      "
                      v-model="item.name"
                      placeholder=""
                    ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xl="8" :xs="24">
                <el-row type="flex" align="middle">
                  <el-col :xl="8" :xs="12" class="passport-row-label"> 班別 Class </el-col>
                  <el-col :xl="8" :xs="12">
                    <el-form-item label="" :prop="'siblingsAtLogosAcademy.siblings.'+index + '.class'" :rules="[{ required: studentParticular.siblingsAtLogosAcademy.isHas, message: '班別未输入', trigger: 'change' }]">
                    <el-input
                      :disabled="
                        !studentParticular.siblingsAtLogosAcademy.isHas ||
                        isView
                      "
                      v-model="item.class"
                      placeholder=""
                    ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xl="8" :xs="24">
                <el-row type="flex" align="middle">
                  <el-col :xl="8" :xs="12" class="passport-row-label"> 學生編號 Student No. </el-col>
                  <el-col :xl="8" :xs="12">
                    <el-form-item label="" :prop="'siblingsAtLogosAcademy.siblings.'+index + '.year'" :rules="[{ required: studentParticular.siblingsAtLogosAcademy.isHas, message: '年份未输入', trigger: 'change' }]">
                    <el-input
                      :disabled="
                        !studentParticular.siblingsAtLogosAcademy.isHas ||
                        isView
                      "
                      v-model="item.year"
                      placeholder=""
                    ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-button
                v-if="!isView && studentParticular.siblingsAtLogosAcademy.isHas"
                @click="onDeleteLogos(index)"
                style="margin-bottom: 10px;"
                icon="el-icon-delete"
                type="primary"
              >
                删除 Delete
              </el-button>
            </div>
            <el-button
              v-if="!isView && studentParticular.siblingsAtLogosAcademy.isHas"
              @click="onAdd"
              icon="el-icon-plus"
              type="primary"
            >
              增加 Add
            </el-button>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="有超過一名子女同時報讀申請 More than one child is applying at Logos Academy">
        <el-radio-group
          :disabled="isView"
          v-model="studentParticular.siblingsIdentityDocument.isHas"
          class="document-identity-radio"
        >
          <el-radio :label="false">
            <div>沒有 No</div>
          </el-radio>
          <el-radio :label="true">
            <div>有 Yes</div>
            <div v-for="(item, index) in studentParticular.siblingsIdentityDocument.siblings" :key="index">
              <el-row
                  type="flex"
                  class="logos-academy passport-row"
                  align="middle"
                  :gutter="6"
                
                >
                  <el-col :xl="8" :xs="24">
                    <el-row type="flex" align="middle">
                      <el-col :xl="13" :xs="12" class="passport-row-label">英文姓名 English Name</el-col>
                      <el-col :xl="11" :xs="12">
                        <el-form-item label="" :prop="'siblingsIdentityDocument.siblings.'+index + '.englishName'" :rules="[{ required: studentParticular.siblingsIdentityDocument.isHas, message: 'englishName is required', trigger: 'change' },{ pattern: /^[A-Z ]+$/, message: '請輸入大寫字母', trigger: 'change' }]">
                        <el-input
                          :disabled="
                            !studentParticular.siblingsIdentityDocument.isHas ||
                            isView
                          "
                          v-model="item.englishName"
                          placeholder=""
                        ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :xl="8" :xs="24">
                    <el-row type="flex" align="middle">
                      <el-col :xl="13" :xs="12" class="passport-row-label">中文姓名 Chinese Name</el-col>
                      <el-col :xl="11" :xs="12">
                        <el-form-item label="" :prop="'siblingsIdentityDocument.siblings.'+index + '.chineseName'" :rules="[{ required: studentParticular.siblingsIdentityDocument.isHas, message: 'chineseName is required', trigger: 'change' }]">
                        <el-input
                          :disabled="
                            !studentParticular.siblingsIdentityDocument.isHas ||
                            isView
                          "
                          v-model="item.chineseName"
                          placeholder=""
                        ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
           
              </el-row>
              <el-row
                  type="flex"
                  class="logos-academy passport-row"
                  align="middle"
                  :gutter="6"
                
                >
                
                  <el-col :xl="8" :xs="24">
                    <el-row type="flex" align="middle">
                      <el-col :xl="8" :xs="12" class="passport-row-label"> 性别 Gender </el-col>
                      <el-col :xl="12" :xs="12">
                        <el-form-item label="" class="siblingsIdentityDocumentGender" :prop="'siblingsIdentityDocument.siblings.'+index + '.gender'" :rules="[{ required: studentParticular.siblingsIdentityDocument.isHas, message: 'gender is required', trigger: 'change' }]">
                        <el-radio-group
                          :disabled="
                            !studentParticular.siblingsIdentityDocument.isHas ||
                            isView
                          "
                          v-model="item.gender"
                        >
                          <el-radio :label="0">男 Male</el-radio>
                          <el-radio :label="1">女 Female</el-radio>
                        </el-radio-group>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
              </el-row>
              <el-radio-group
                  :disabled="isView || !studentParticular.siblingsIdentityDocument.isHas"
                  v-model="item.type"
                  class="document-identity-radio"
                >
                  <el-radio :label="0">
                    <el-row
                      type="flex"
                      align="middle"
                      justify="space-between"
                      class="passport-row"
                      :gutter="8"
                    >
                      <el-col :xl="9" :xs="24" class="wordWrap passport-row-label">
                        <div class="wordWrap">
                          出生證明書/香港身份證 Birth Cert./Hong Kong ID card
                        </div>
                        證件號碼 Certificate No.
                      </el-col>
                      <el-col :xl="14" :xs="24">
                        <el-row type="flex" align="middle">
                          <el-col :xl="2" :xs="8">
                            <el-form-item
                            
                              :prop="'siblingsIdentityDocument.siblings.'+index + '.certificateNoTop'"
                              :rules="[
                                {
                                  required:
                                    item.type == 0 && studentParticular.siblingsIdentityDocument.isHas,
                                  message: 'is required',
                                  trigger: 'blur',
                                },
                                {
                                  pattern: /^[A-Z]+$/,
                                  message: '請輸入數字或大寫字母',
                                  trigger: 'blur',
                                },
                              ]"
                            >
                              <el-input
                                :maxlength="1"
                                :disabled="item.type != 0 ||  !studentParticular.siblingsIdentityDocument.isHas || isView"
                                v-model="item.certificateNoTop"
                                placeholder=""
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="1" style="text-align: center">-</el-col>
                          <el-col :xl="4" :xs="8">
                            <el-form-item
                          
                              :prop="'siblingsIdentityDocument.siblings.'+index + '.certificateNoCont'"
                              :rules="[
                                {
                                  required:
                                    item.type == 0 && studentParticular.siblingsIdentityDocument.isHas,
                                  message: 'is required',
                                  trigger: 'blur',
                                },
                                {
                                  pattern: /^[0-9]+$/,
                                  message: '請輸入純數字',
                                  trigger: 'blur',
                                },
                              ]"
                            >
                              <el-input
                                :maxlength="6"
                                :disabled="item.type != 0 ||  !studentParticular.siblingsIdentityDocument.isHas || isView"
                                v-model="item.certificateNoCont"
                                placeholder=""
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :xl="3" :xs="8">
                            <el-form-item
                            
                              :prop="'siblingsIdentityDocument.siblings.'+index + '.certificateNoBottom'"
                              :rules="[
                                {
                                  required:
                                    item.type == 0 && studentParticular.siblingsIdentityDocument.isHas,
                                  message: 'is required',
                                  trigger: 'blur',
                                },
                                {
                                  pattern: /^[0-9A-Z]+$/,
                                  message: '請输入数字或大写字母',
                                  trigger: 'blur',
                                },
                              ]"
                            >
                              (<el-input
                                :maxlength="1"
                               :disabled="item.type != 0 ||  !studentParticular.siblingsIdentityDocument.isHas || isView"
                                v-model="item.certificateNoBottom"
                                placeholder=""
                              ></el-input
                              >)
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-radio>
                  <el-radio :label="1">
                    <div>護照 Passport</div>
                    <el-row type="flex" class="passport-row" align="middle" :gutter="6">
                      <el-col :xl="12" :xs="24">
                        <el-row type="flex" align="middle">
                          <el-col :span="13" class="passport-row-label">
                            <span>證件號碼 Passport No.</span>
                          </el-col>
                          <el-col :span="11">
                            <el-form-item
                              style="display: inline-block"
                              
                              :prop="'siblingsIdentityDocument.siblings.'+index + '.passportNo'"
                              :rules="[
                                {
                                  required:
                                    item.type == 1 && studentParticular.siblingsIdentityDocument.isHas,
                                  message: 'is required',
                                  trigger: 'blur',
                                },
                                {
                                  pattern: /^[0-9A-Za-z]+$/,
                                  message: '請输入数字或字母',
                                  trigger: 'blur',
                                },
                              ]"
                            >
                              <el-input
                                :disabled="item.type != 1 ||  !studentParticular.siblingsIdentityDocument.isHas || isView"
                                v-model="
                                  item.passportNo
                                "
                                placeholder=""
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :xl="12" :xs="24">
                        <el-row type="flex"  align="middle">
                          <el-col :span="6" class="passport-row-label">
                            <span>國家 Country</span>
                          </el-col>
                          <el-col :span="18">
                            <el-form-item
                              style="display: inline-block"
                              
                              :prop="'siblingsIdentityDocument.siblings.'+index + '.country'"
                              :rules="[
                                {
                                  required:
                                    item.type == 1 && studentParticular.siblingsIdentityDocument.isHas,
                                  message: 'is required',
                                  trigger: 'blur',
                                },
                              ]"
                            >
                            <el-row :gutter="10" type="flex" align="middle">
                                <el-col :span="12">
                                  <el-select
                                    :disabled="item.type != 1 ||  !studentParticular.siblingsIdentityDocument.isHas || isView"
                                    v-model="
                                      item.country
                                    "
                                    placeholder=""
                                  >
                                    <el-option
                                      v-for="(item, index) in nationality"
                                      :key="index"
                                      :label="item.label"
                                      :value="item.value"
                                    ></el-option>
                                  </el-select>
                                </el-col>
                                <el-col
                                  v-if="item.country == '其他 Others'"
                                  :span="12"
                                >
                                  <el-input
                                    :disabled="item.type != 1 ||  !studentParticular.siblingsIdentityDocument.isHas || isView"
                                    v-model="item.countryInput"
                                  ></el-input>
                                </el-col>
                              </el-row>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-radio>
              </el-radio-group>
              <el-button
                v-if="!isView && studentParticular.siblingsIdentityDocument.isHas"
                @click="onDeleteAcademy(index)"
                style="margin-bottom: 10px;"
                icon="el-icon-delete"
                type="primary"
              >
                删除 Delete
              </el-button>
            </div>
            <el-button
              v-if="!isView && studentParticular.siblingsIdentityDocument.isHas"
              @click="onAddAcademy"
              icon="el-icon-plus"
              type="primary"
            >
              增加 Add
            </el-button>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="有辦學團體或法團校董會推薦 Recommended by School Sponsoring Bodies or Incorporated Management Committees">
        <el-radio-group :disabled="isView" v-removeAriaHidden @change="changeIncorporatedManagementCommittees" v-model="studentParticular.recommendedSchoolBoard.isHas"
          class="document-identity-radio">
          <el-radio :label="false">
            <div>沒有 No</div>
          </el-radio>
          <el-radio :label="true">
            <div>有 Yes</div>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem; margin-top: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">推薦人姓名 Recommender's name </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedSchoolBoard.recommenderName'" :rules="[
                  {
                    required:
                      studentParticular.recommendedSchoolBoard.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change'],
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedSchoolBoard.isHas ||
                    isView
                    " v-model="studentParticular.recommendedSchoolBoard.recommenderName
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">聯絡方式 Contact method </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedSchoolBoard.recommenderContactMethod'" :rules="[
                  {
                    required:
                    studentParticular.recommendedSchoolBoard.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change'],
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedSchoolBoard.isHas ||
                    isView
                    " v-model="studentParticular.recommendedSchoolBoard.recommenderContactMethod
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">與學生關係 Relationship with the student </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedSchoolBoard.relationshipWithTheStudent'" :rules="[
                  {
                    required:
                      studentParticular.recommendedSchoolBoard.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change'],
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedSchoolBoard.isHas ||
                    isView
                    " v-model="studentParticular.recommendedSchoolBoard.relationshipWithTheStudent
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="有现任教職員推薦 Recommended by Current Staff">
        <el-radio-group :disabled="isView" v-removeAriaHidden v-model="studentParticular.recommendedCurrentStaff.isHas"
          @change="changeCurrentStaff" class="document-identity-radio">
          <el-radio :label="false">
            <div>沒有 No</div>
          </el-radio>
          <el-radio :label="true">
            <div>有 Yes</div>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem; margin-top: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">推薦人姓名 Recommender's name </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedCurrentStaff.recommenderName'" :rules="[
                  {
                    required:
                      studentParticular.recommendedCurrentStaff.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change'],
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedCurrentStaff.isHas ||
                    isView
                    " v-model="studentParticular.recommendedCurrentStaff.recommenderName
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">聯絡方式 Contact method </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedCurrentStaff.recommenderContactMethod'" :rules="[
                  {
                    required:
                      studentParticular.recommendedCurrentStaff.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change'],
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedCurrentStaff.isHas ||
                    isView
                    " v-model="studentParticular.recommendedCurrentStaff.recommenderContactMethod
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">與學生關係 Relationship with the student </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedCurrentStaff.relationshipWithTheStudent'" :rules="[
                  {
                    required:
                      studentParticular.recommendedCurrentStaff.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change'],
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedCurrentStaff.isHas ||
                    isView
                    " v-model="studentParticular.recommendedCurrentStaff.relationshipWithTheStudent
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="有校友子女推薦 Recommended by Child of an Alumnus">
        <el-radio-group :disabled="isView" v-removeAriaHidden v-model="studentParticular.recommendedChildAlumnus.isHas"
          @change="changeChildOfAlumnus" class="document-identity-radio">
          <el-radio :label="false">
            <div>沒有 No</div>
          </el-radio>
          <el-radio :label="true">
            <div>有 Yes</div>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;margin-top: 1.25rem;" >
              <el-col :xl="12" :xs="24" class="passport-row-label">推薦人姓名 Recommender's name </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedChildAlumnus.recommenderName'" :rules="[
                  {
                    required:
                      studentParticular.recommendedChildAlumnus.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change']
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedChildAlumnus.isHas ||
                    isView
                    " v-model="studentParticular.recommendedChildAlumnus.recommenderName
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">聯絡方式 Contact method </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedChildAlumnus.recommenderContactMethod'" :rules="[
                  {
                    required:
                      studentParticular.recommendedChildAlumnus.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change']
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedChildAlumnus.isHas ||
                    isView
                    " v-model="studentParticular.recommendedChildAlumnus.recommenderContactMethod
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;" :gutter="20">
              <el-col :xl="8" :xs="24">
                <el-row type="flex" align="middle" class="passport-row">
                  <el-col :xl="8" :xs="24" class="passport-row-label">最終就讀班級 Last attended class </el-col>
                  <el-col :xl="16" :xs="24">
                    <el-form-item :prop="'recommendedChildAlumnus.recommenderLastAttendedClass'" :rules="[
                      {
                        required:
                          studentParticular.recommendedChildAlumnus.isHas,
                        message: 'is required',
                        trigger: ['blur', 'change']
                      }]">
                      <el-input :disabled="!studentParticular.recommendedChildAlumnus.isHas ||
                        isView
                        " v-model="studentParticular.recommendedChildAlumnus.recommenderLastAttendedClass
                          " placeholder=""></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xl="8" :xs="24">
                <el-row type="flex" align="middle" class="passport-row">
                  <el-col :xl="8" :xs="24" class="passport-row-label">學號 Student ID </el-col>
                  <el-col :xl="16" :xs="24">
                    <el-form-item :prop="'recommendedChildAlumnus.recommenderStudentId'" :rules="[
                      {
                        required:
                          studentParticular.recommendedChildAlumnus.isHas,
                        message: 'is required',
                        trigger: ['blur', 'change']
                      }]">
                      <el-input :disabled="!studentParticular.recommendedChildAlumnus.isHas ||
                        isView
                        " v-model="studentParticular.recommendedChildAlumnus.recommenderStudentId
                          " placeholder=""></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xl="8" :xs="24">
                <el-row type="flex" align="middle" class="passport-row">
                  <el-col :xl="8" :xs="24" class="passport-row-label">畢業年份 Graduation year </el-col>
                  <el-col :xl="16" :xs="24">
                    <el-form-item :prop="'recommendedChildAlumnus.recommenderGraduationYear'" :rules="[
                      {
                        required:
                          studentParticular.recommendedChildAlumnus.isHas,
                        message: 'is required',
                        trigger: ['blur', 'change']
                      },
                      //4位数字
                      {
                        pattern: /^\d{4}$/,
                        message: 'Please enter a number with a length of 4',
                        trigger: ['blur', 'change']
                      },
                    ]">
                      <el-input :disabled="!studentParticular.recommendedChildAlumnus.isHas ||
                        isView
                        " v-model="studentParticular.recommendedChildAlumnus.recommenderGraduationYear
                          " placeholder="" maxlength="4"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="有其他推薦 Recommended by Others">
        <el-radio-group :disabled="isView" v-removeAriaHidden v-model="studentParticular.recommendedOthers.isHas"
          @change="changeRecommendedByOthers" class="document-identity-radio">
          
          <el-radio :label="false">
            <div>沒有 No</div>
          </el-radio>

          <el-radio :label="true">
              <div>有 Yes</div>
              <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem; margin-top: 1.25rem;">
                <el-col :xl="12" :xs="24" class="passport-row-label">推薦人姓名 Recommender's name </el-col>
                <el-col :xl="12" :xs="24">
                  <el-form-item :prop="'recommendedOthers.recommenderName'" :rules="[
                    {
                      required:
                        studentParticular.recommendedOthers.isHas,
                      message: 'is required',
                      trigger: 'blur',
                    },
                  ]">
                    <el-input :disabled="!studentParticular.recommendedOthers.isHas ||
                      isView
                      " v-model="studentParticular.recommendedOthers.recommenderName
                            " placeholder=""></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;">
                <el-col :xl="12" :xs="24" class="passport-row-label">聯絡方式 Contact method </el-col>
                <el-col :xl="12" :xs="24">
                  <el-form-item :prop="'recommendedOthers.recommenderContactMethod'" :rules="[
                    {
                      required:
                        studentParticular.recommendedOthers.isHas,
                      message: 'is required',
                      trigger: 'blur',
                    },
                  ]">
                    <el-input :disabled="!studentParticular.recommendedOthers.isHas ||
                      isView
                      " v-model="studentParticular.recommendedOthers.recommenderContactMethod
                            " placeholder=""></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;">
                <el-col :xl="12" :xs="24" class="passport-row-label">與本校關係 Relationship with our school </el-col>
                <el-col :xl="12" :xs="24">
                  <el-form-item :prop="'recommendedOthers.relationshipWitheOurSchool'" :rules="[
                    {
                      required:
                        studentParticular.recommendedOthers.isHas,
                      message: 'is required',
                      trigger: 'blur',
                    },
                  ]">
                    <el-input :disabled="!studentParticular.recommendedOthers.isHas ||
                      isView
                      " v-model="studentParticular.recommendedOthers.relationshipWitheOurSchool
                            " placeholder=""></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;">
                <el-col :xl="12" :xs="24" class="passport-row-label">與學生關係 Relationship with the student </el-col>
                <el-col :xl="12" :xs="24">
                  <el-form-item :prop="'recommendedOthers.relationshipWithTheStudent'" :rules="[
                    {
                      required:
                        studentParticular.recommendedOthers.isHas,
                      message: 'is required',
                      trigger: 'blur',
                    },
                  ]">
                    <el-input :disabled="!studentParticular.recommendedOthers.isHas ||
                      isView
                      " v-model="studentParticular.recommendedOthers.relationshipWithTheStudent
                            " placeholder=""></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
          </el-radio>

        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="兄／姊在真道書院就讀 Sibling(s) studying in Logos Academy">
        <el-radio-group
          :disabled="isView"
          v-model="studentParticular.siblingsAtLogosAcademy.isHas"
          class="document-identity-radio"
        >
          <el-radio :label="false">
            <div>沒有 No</div>
          </el-radio>
          <el-radio :label="true">
            <div>有 Yes</div>
            <div v-for="(item, index) in studentParticular.siblingsAtLogosAcademy.siblings" :key="index">
            <el-row
              type="flex"
              class="logos-academy passport-row"
              align="middle"
              :gutter="6"
            >
              <el-col :xl="8" :xs="24">
                <el-row type="flex" align="middle">
                  <el-col :xl="8" :xs="12" class="passport-row-label"> 姓名 Name </el-col>
                  <el-col :xl="8" :xs="12">
                    <el-form-item label="" :prop="'siblingsAtLogosAcademy.siblings.'+index + '.name'" :rules="[{ required: studentParticular.siblingsAtLogosAcademy.isHas, message: '姓名未输入', trigger: 'change' }]">
                    <el-input
                      :disabled="
                        !studentParticular.siblingsAtLogosAcademy.isHas ||
                        isView
                      "
                      v-model="item.name"
                      placeholder=""
                    ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xl="8" :xs="24">
                <el-row type="flex" align="middle">
                  <el-col :xl="8" :xs="12" class="passport-row-label"> 班別 Class </el-col>
                  <el-col :xl="8" :xs="12">
                    <el-form-item label="" :prop="'siblingsAtLogosAcademy.siblings.'+index + '.class'" :rules="[{ required: studentParticular.siblingsAtLogosAcademy.isHas, message: '班別未输入', trigger: 'change' }]">
                    <el-input
                      :disabled="
                        !studentParticular.siblingsAtLogosAcademy.isHas ||
                        isView
                      "
                      v-model="item.class"
                      placeholder=""
                    ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xl="8" :xs="24">
                <el-row type="flex" align="middle">
                  <el-col :xl="8" :xs="12" class="passport-row-label"> 學生編號 Student No. </el-col>
                  <el-col :xl="8" :xs="12">
                    <el-form-item label="" :prop="'siblingsAtLogosAcademy.siblings.'+index + '.year'" :rules="[{ required: studentParticular.siblingsAtLogosAcademy.isHas, message: '年份未输入', trigger: 'change' }]">
                    <el-input
                      :disabled="
                        !studentParticular.siblingsAtLogosAcademy.isHas ||
                        isView
                      "
                      v-model="item.year"
                      placeholder=""
                    ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-button
                v-if="!isView && studentParticular.siblingsAtLogosAcademy.isHas"
                @click="onDeleteLogos(index)"
                style="margin-bottom: 10px;"
                icon="el-icon-delete"
                type="primary"
              >
                删除 Delete
              </el-button>
            </div>
            <el-button
              v-if="!isView && studentParticular.siblingsAtLogosAcademy.isHas"
              @click="onAdd"
              icon="el-icon-plus"
              type="primary"
            >
              增加 Add
            </el-button>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="有超過一名子女同時報讀申請 More than one child is applying at Logos Academy">
        <el-radio-group
          :disabled="isView"
          v-model="studentParticular.siblingsIdentityDocument.isHas"
          class="document-identity-radio"
        >
          <el-radio :label="false">
            <div>沒有 No</div>
          </el-radio>
          <el-radio :label="true">
            <div>有 Yes</div>
            <div v-for="(item, index) in studentParticular.siblingsIdentityDocument.siblings" :key="index">
              <el-row
                  type="flex"
                  class="logos-academy passport-row"
                  align="middle"
                  :gutter="6"
                
                >
                  <el-col :xl="8" :xs="24">
                    <el-row type="flex" align="middle">
                      <el-col :xl="13" :xs="12" class="passport-row-label">英文姓名 English Name</el-col>
                      <el-col :xl="11" :xs="12">
                        <el-form-item label="" :prop="'siblingsIdentityDocument.siblings.'+index + '.englishName'" :rules="[{ required: studentParticular.siblingsIdentityDocument.isHas, message: 'englishName is required', trigger: 'change' },{ pattern: /^[A-Z ]+$/, message: '請輸入大寫字母', trigger: 'change' }]">
                        <el-input
                          :disabled="
                            !studentParticular.siblingsIdentityDocument.isHas ||
                            isView
                          "
                          v-model="item.englishName"
                          placeholder=""
                        ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :xl="8" :xs="24">
                    <el-row type="flex" align="middle">
                      <el-col :xl="13" :xs="12" class="passport-row-label">中文姓名 Chinese Name</el-col>
                      <el-col :xl="11" :xs="12">
                        <el-form-item label="" :prop="'siblingsIdentityDocument.siblings.'+index + '.chineseName'" :rules="[{ required: studentParticular.siblingsIdentityDocument.isHas, message: 'chineseName is required', trigger: 'change' }]">
                        <el-input
                          :disabled="
                            !studentParticular.siblingsIdentityDocument.isHas ||
                            isView
                          "
                          v-model="item.chineseName"
                          placeholder=""
                        ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
           
              </el-row>
              <el-row
                  type="flex"
                  class="logos-academy passport-row"
                  align="middle"
                  :gutter="6"
                
                >
                
                  <el-col :xl="8" :xs="24">
                    <el-row type="flex" align="middle">
                      <el-col :xl="8" :xs="12"> 性别 Gender </el-col>
                      <el-col :xl="12" :xs="12">
                        <el-form-item label="" class="siblingsIdentityDocumentGender" :prop="'siblingsIdentityDocument.siblings.'+index + '.gender'" :rules="[{ required: studentParticular.siblingsIdentityDocument.isHas, message: 'gender is required', trigger: 'change' }]">
                        <el-radio-group
                          :disabled="
                            !studentParticular.siblingsIdentityDocument.isHas ||
                            isView
                          "
                          v-model="item.gender"
                        >
                          <el-radio :label="0">男 Male</el-radio>
                          <el-radio :label="1">女 Female</el-radio>
                        </el-radio-group>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
              </el-row>
              <el-radio-group
                  :disabled="isView || !studentParticular.siblingsIdentityDocument.isHas"
                  v-model="item.type"
                  class="document-identity-radio"
                >
                  <el-radio :label="0">
                    <el-row
                      type="flex"
                      align="middle"
                      justify="space-between"
                      class="passport-row"
                    
                    >
                      <el-col :xl="9" :xs="24" class="wordWrap passport-row-label">
                        <div class="wordWrap">
                          出生證明書/香港身份證 Birth Cert./Hong Kong ID card
                        </div>
                        證件號碼 Certificate No.
                      </el-col>
                      <el-col :xl="14" :xs="24">
                        <el-row type="flex" align="middle">
                          <el-col :xl="2" :xs="8">
                            <el-form-item
                            
                              :prop="'siblingsIdentityDocument.siblings.'+index + '.certificateNoTop'"
                              :rules="[
                                {
                                  required:
                                    item.type == 0 && studentParticular.siblingsIdentityDocument.isHas,
                                  message: 'is required',
                                  trigger: 'blur',
                                },
                                {
                                  pattern: /^[A-Z]+$/,
                                  message: '請輸入數字或大寫字母',
                                  trigger: 'blur',
                                },
                              ]"
                            >
                              <el-input
                                :maxlength="1"
                                :disabled="item.type != 0 ||  !studentParticular.siblingsIdentityDocument.isHas || isView"
                                v-model="item.certificateNoTop"
                                placeholder=""
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="1" style="text-align: center">-</el-col>
                          <el-col :xl="4" :xs="8">
                            <el-form-item
                          
                              :prop="'siblingsIdentityDocument.siblings.'+index + '.certificateNoCont'"
                              :rules="[
                                {
                                  required:
                                    item.type == 0 && studentParticular.siblingsIdentityDocument.isHas,
                                  message: 'is required',
                                  trigger: 'blur',
                                },
                                {
                                  pattern: /^[0-9]+$/,
                                  message: '請輸入純數字',
                                  trigger: 'blur',
                                },
                              ]"
                            >
                              <el-input
                                :maxlength="6"
                                :disabled="item.type != 0 ||  !studentParticular.siblingsIdentityDocument.isHas || isView"
                                v-model="item.certificateNoCont"
                                placeholder=""
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :xl="3" :xs="8">
                            <el-form-item
                            
                              :prop="'siblingsIdentityDocument.siblings.'+index + '.certificateNoBottom'"
                              :rules="[
                                {
                                  required:
                                    item.type == 0 && studentParticular.siblingsIdentityDocument.isHas,
                                  message: 'is required',
                                  trigger: 'blur',
                                },
                                {
                                  pattern: /^[0-9A-Z]+$/,
                                  message: '請输入数字或大写字母',
                                  trigger: 'blur',
                                },
                              ]"
                            >
                              (<el-input
                                :maxlength="1"
                               :disabled="item.type != 0 ||  !studentParticular.siblingsIdentityDocument.isHas || isView"
                                v-model="item.certificateNoBottom"
                                placeholder=""
                              ></el-input
                              >)
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-radio>
                  <el-radio :label="1">
                    <div>護照 Passport</div>
                    <el-row type="flex" class="passport-row" align="middle" :gutter="6">
                      <el-col :xl="12" :xs="24">
                        <el-row type="flex" align="middle">
                          <el-col :span="13" class="passport-row-label">
                            <span>證件號碼 Passport No.</span>
                          </el-col>
                          <el-col :span="11">
                            <el-form-item
                              style="display: inline-block"
                              
                              :prop="'siblingsIdentityDocument.siblings.'+index + '.passportNo'"
                              :rules="[
                                {
                                  required:
                                    item.type == 1 && studentParticular.siblingsIdentityDocument.isHas,
                                  message: 'is required',
                                  trigger: 'blur',
                                },
                                {
                                  pattern: /^[0-9A-Za-z]+$/,
                                  message: '請输入数字或字母',
                                  trigger: 'blur',
                                },
                              ]"
                            >
                              <el-input
                                :disabled="item.type != 1 ||  !studentParticular.siblingsIdentityDocument.isHas || isView"
                                v-model="
                                  item.passportNo
                                "
                                placeholder=""
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :xl="12" :xs="24">
                        <el-row type="flex"  align="middle">
                          <el-col :span="6" class="passport-row-label">
                            <span>國家 Country</span>
                          </el-col>
                          <el-col :span="18">
                            <el-form-item
                              style="display: inline-block"
                              
                              :prop="'siblingsIdentityDocument.siblings.'+index + '.country'"
                              :rules="[
                                {
                                  required:
                                    item.type == 1 && studentParticular.siblingsIdentityDocument.isHas,
                                  message: 'is required',
                                  trigger: 'blur',
                                },
                              ]"
                            >
                            <el-row :gutter="10" type="flex" align="middle">
                                <el-col :span="12">
                                  <el-select
                                    :disabled="item.type != 1 ||  !studentParticular.siblingsIdentityDocument.isHas || isView"
                                    v-model="
                                      item.country
                                    "
                                    placeholder=""
                                  >
                                    <el-option
                                      v-for="(item, index) in nationality"
                                      :key="index"
                                      :label="item.label"
                                      :value="item.value"
                                    ></el-option>
                                  </el-select>
                                </el-col>
                                <el-col
                                  v-if="item.country == '其他 Others'"
                                  :span="12"
                                >
                                  <el-input
                                    :disabled="item.type != 1 ||  !studentParticular.siblingsIdentityDocument.isHas || isView"
                                    v-model="item.countryInput"
                                  ></el-input>
                                </el-col>
                              </el-row>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-radio>
              </el-radio-group>
              <el-button
                v-if="!isView && studentParticular.siblingsIdentityDocument.isHas"
                @click="onDeleteAcademy(index)"
                style="margin-bottom: 10px;"
                icon="el-icon-delete"
                type="primary"
              >
                删除 Delete
              </el-button>
            </div>
            <el-button
              v-if="!isView && studentParticular.siblingsIdentityDocument.isHas"
              @click="onAddAcademy"
              icon="el-icon-plus"
              type="primary"
            >
              增加 Add
            </el-button>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="父／母/ 祖父/ 祖母為真道書院的校董 Parent(s)/ Grandparent(s) being a school manager of  Logos Academy">
        <el-radio-group :disabled="isView" v-removeAriaHidden @change="changeIncorporatedManagementCommittees" v-model="studentParticular.recommendedSchoolBoard.isHas"
          class="document-identity-radio">
          <el-radio :label="false">
            <div>沒有 No</div>
          </el-radio>
          <el-radio :label="true">
            <div>有 Yes</div>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem; margin-top: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">校董姓名 Name of school manager </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedSchoolBoard.recommenderName'" :rules="[
                  {
                    required:
                      studentParticular.recommendedSchoolBoard.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change'],
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedSchoolBoard.isHas ||
                    isView
                    " v-model="studentParticular.recommendedSchoolBoard.recommenderName
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">聯絡電話 Contact number </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedSchoolBoard.recommenderContactMethod'" :rules="[
                  {
                    required:
                    studentParticular.recommendedSchoolBoard.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change'],
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedSchoolBoard.isHas ||
                    isView
                    " v-model="studentParticular.recommendedSchoolBoard.recommenderContactMethod
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">與學生關係 Relationship with the student </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedSchoolBoard.relationshipWithTheStudent'" :rules="[
                  {
                    required:
                      studentParticular.recommendedSchoolBoard.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change'],
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedSchoolBoard.isHas ||
                    isView
                    " v-model="studentParticular.recommendedSchoolBoard.relationshipWithTheStudent
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="父／母全職在真道書院工作 Parent(s) teaching or working full-time in Logos Academy">
        <el-radio-group :disabled="isView" v-removeAriaHidden v-model="studentParticular.recommendedCurrentStaff.isHas"
          @change="changeCurrentStaff" class="document-identity-radio">
          <el-radio :label="false">
            <div>沒有 No</div>
          </el-radio>
          <el-radio :label="true">
            <div>有 Yes</div>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem; margin-top: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">教職員姓名 Name of staff  </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedCurrentStaff.recommenderName'" :rules="[
                  {
                    required:
                      studentParticular.recommendedCurrentStaff.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change'],
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedCurrentStaff.isHas ||
                    isView
                    " v-model="studentParticular.recommendedCurrentStaff.recommenderName
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">聯絡電話 Contact number </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedCurrentStaff.recommenderContactMethod'" :rules="[
                  {
                    required:
                      studentParticular.recommendedCurrentStaff.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change'],
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedCurrentStaff.isHas ||
                    isView
                    " v-model="studentParticular.recommendedCurrentStaff.recommenderContactMethod
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">與學生關係 Relationship with the student </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedCurrentStaff.relationshipWithTheStudent'" :rules="[
                  {
                    required:
                      studentParticular.recommendedCurrentStaff.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change'],
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedCurrentStaff.isHas ||
                    isView
                    " v-model="studentParticular.recommendedCurrentStaff.relationshipWithTheStudent
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="父／母或兄／姊為真道書院的畢業生 Parent(s) or sibling(s) being a graduate of Logos Academy">
        <el-radio-group :disabled="isView" v-removeAriaHidden v-model="studentParticular.recommendedChildAlumnus.isHas"
          @change="changeChildOfAlumnus" class="document-identity-radio">
          <el-radio :label="false">
            <div>沒有 No</div>
          </el-radio>
          <el-radio :label="true">
            <div>有 Yes</div>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;margin-top: 1.25rem;" >
              <el-col :xl="12" :xs="24" class="passport-row-label">畢業生姓名 Name of graduate </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedChildAlumnus.recommenderName'" :rules="[
                  {
                    required:
                      studentParticular.recommendedChildAlumnus.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change']
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedChildAlumnus.isHas ||
                    isView
                    " v-model="studentParticular.recommendedChildAlumnus.recommenderName
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">聯絡電話 Contact number </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedChildAlumnus.recommenderContactMethod'" :rules="[
                  {
                    required:
                      studentParticular.recommendedChildAlumnus.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change']
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedChildAlumnus.isHas ||
                    isView
                    " v-model="studentParticular.recommendedChildAlumnus.recommenderContactMethod
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;" :gutter="20">
              <el-col :xl="8" :xs="24">
                <el-row type="flex" align="middle" class="passport-row">
                  <el-col :xl="8" :xs="24" class="passport-row-label">最終就讀班級 Last attended class </el-col>
                  <el-col :xl="16" :xs="24">
                    <el-form-item :prop="'recommendedChildAlumnus.recommenderLastAttendedClass'" :rules="[
                      {
                        required:
                          studentParticular.recommendedChildAlumnus.isHas,
                        message: 'is required',
                        trigger: ['blur', 'change']
                      }]">
                      <el-input :disabled="!studentParticular.recommendedChildAlumnus.isHas ||
                        isView
                        " v-model="studentParticular.recommendedChildAlumnus.recommenderLastAttendedClass
                          " placeholder=""></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xl="8" :xs="24">
                <el-row type="flex" align="middle" class="passport-row">
                  <el-col :xl="8" :xs="24" class="passport-row-label">學號 Student ID </el-col>
                  <el-col :xl="16" :xs="24">
                    <el-form-item :prop="'recommendedChildAlumnus.recommenderStudentId'" :rules="[
                      {
                        required:
                          studentParticular.recommendedChildAlumnus.isHas,
                        message: 'is required',
                        trigger: ['blur', 'change']
                      }]">
                      <el-input :disabled="!studentParticular.recommendedChildAlumnus.isHas ||
                        isView
                        " v-model="studentParticular.recommendedChildAlumnus.recommenderStudentId
                          " placeholder=""></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xl="8" :xs="24">
                <el-row type="flex" align="middle" class="passport-row">
                  <el-col :xl="8" :xs="24" class="passport-row-label">畢業年份 Graduation year </el-col>
                  <el-col :xl="16" :xs="24">
                    <el-form-item :prop="'recommendedChildAlumnus.recommenderGraduationYear'" :rules="[
                      {
                        required:
                          studentParticular.recommendedChildAlumnus.isHas,
                        message: 'is required',
                        trigger: ['blur', 'change']
                      },
                      //4位数字
                      {
                        pattern: /^\d{4}$/,
                        message: 'Please enter a number with a length of 4',
                        trigger: ['blur', 'change']
                      },
                    ]">
                      <el-input :disabled="!studentParticular.recommendedChildAlumnus.isHas ||
                        isView
                        " v-model="studentParticular.recommendedChildAlumnus.recommenderGraduationYear
                          " placeholder="" maxlength="4"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="passport-row" style="margin-bottom: 1.25rem;">
              <el-col :xl="12" :xs="24" class="passport-row-label">與學生關係 Relationship with the student </el-col>
              <el-col :xl="12" :xs="24">
                <el-form-item :prop="'recommendedChildAlumnus.relationshipWithTheStudent'" :rules="[
                  {
                    required:
                      studentParticular.recommendedChildAlumnus.isHas,
                    message: 'is required',
                    trigger: ['blur', 'change'],
                  },
                ]">
                  <el-input :disabled="!studentParticular.recommendedChildAlumnus.isHas ||
                    isView
                    " v-model="studentParticular.recommendedChildAlumnus.relationshipWithTheStudent
                          " placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="!isView && !adminEdit"
        label=""
        class="form-item-primary-button"
        style="text-align: center"
      >
        <el-button type="primary" @click="onSave"> 儲存 Save </el-button>
        <el-button type="primary" @click="onSaveAndContinue">
          下一頁 Next
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import moment from "moment";
import formTitle from "@/components/formTitle";
export default {
  components: { formTitle },
  props: {
    studentParticular: {
      type: Object,
      default: function () {},
    },
    isView: {
      type: Boolean,
      default: false,
    },
    adminEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    //證件號碼
    certificateNo() {
      return (
        this.studentParticular.certificateNoTop +
        this.studentParticular.certificateNoCont +
        this.studentParticular.certificateNoBottom
      );
    },
  },
  watch: {
    certificateNo:{
      handler(v) {
        this.studentParticular.typeOfIdentityDocument.certificateNo = v;
      },
      deep:true,
      immediate:true,
    },
   'studentParticular.typeOfIdentityDocument':{
      handler(v){
        if (v != null) {
          if(this.isView || this.adminEdit){
            this.initTypeOfIdentityDocument();
          }
        }
      },
      deep:true,
      immediate:true,
    },
    'isView':{
      handler(v){
        if (v != null) {
          if(this.isView || this.adminEdit){
            this.initSiblingsIdentityDocument();
          }
        }
      },
      deep:true,
      immediate:true,
    },
  },
  mounted() {
    this.initial()
  },
  data() {
    return {
     expireTimeOPtion: {},
     defaultTime: '',
    };
  },
  created() {
    this.initial()
    
  },
  methods: {
    initial(){
      let that = this;
      that.defaultTime  = that.setExpireTimeOPtion()
      that.expireTimeOPtion = {
        disabledDate(time) {
          return time.getTime() > that.setExpireTimeOPtion(); //如果没有后面的-8.64e7就是不可以选择今天的
        },
      }
      this.$forceUpdate()
    },
    setExpireTimeOPtion(){
       let startTime = moment()
       let endTime =  moment(moment().year() + '/' + '9' + '/' + '1')
       if(startTime.isSameOrBefore(endTime)){
         return moment(endTime).subtract(4, "years").subtract(8, 'months').subtract(1, 'days')
       }else {
        return moment(endTime).subtract(3, "years").subtract(8, 'months').subtract(1, 'days')
       }
    },
    initSiblingsIdentityDocument(){
      if(this.studentParticular.siblingsIdentityDocument.isHas){
        this.studentParticular.siblingsIdentityDocument.siblings.map((v)=>{
           if(v.type == 0){
             v.certificateNoTop = v.certificateNo.slice(0, 1)
             v.certificateNoCont = v.certificateNo.slice(1, v.certificateNo.length -1)
             v.certificateNoBottom = v.certificateNo.slice( v.certificateNo.length -1, v.certificateNo.length)
           }
           return v
        })
         this.studentParticular.siblingsIdentityDocument.siblings.forEach((element,index) => {
          this.$set(this.studentParticular.siblingsIdentityDocument.siblings,index,element)
        });
      }
    },
    initTypeOfIdentityDocument() {
      if (this.studentParticular.typeOfIdentityDocument.type == 0) {
        this.studentParticular.certificateNoTop =
          this.studentParticular.typeOfIdentityDocument.certificateNo.slice(
            0,
            1
          );
        this.studentParticular.certificateNoCont =
          this.studentParticular.typeOfIdentityDocument.certificateNo.slice(
            1,
            this.studentParticular.typeOfIdentityDocument.certificateNo.length -
              1
          );
        this.studentParticular.certificateNoBottom =
          this.studentParticular.typeOfIdentityDocument.certificateNo.slice(
            this.studentParticular.typeOfIdentityDocument.certificateNo.length -
              1,
            this.studentParticular.typeOfIdentityDocument.certificateNo.length
          );
       
        this.$forceUpdate();
      }
    },
    onDeleteLogos(index){
      this.studentParticular.siblingsAtLogosAcademy.siblings.splice(index, 1)
    },
    onDeleteAcademy(index){
      this.studentParticular.siblingsIdentityDocument.siblings.splice(index, 1)
    },
    onAddAcademy() {
      let newSiblings = {
              chineseName: "",
              englishName: "",
              gender: "",
              type: 0,
              certificateNo: "",
              certificateNoTop: "",
              certificateNoCont: "",
              certificateNoBottom: "",
              passportNo: "",
              country: "",
            };
      this.studentParticular.siblingsIdentityDocument.siblings.push(newSiblings);
    },
    onAdd() {
      let newSiblings = {
        name: "",
        class: "",
        year: "",
      };
      this.studentParticular.siblingsAtLogosAcademy.siblings.push(newSiblings);
    },
    setTypeOfIdentityDocument() {
      if (this.studentParticular.typeOfIdentityDocument.type == 0) {
        this.studentParticular.typeOfIdentityDocument.certificateNo = this.certificateNo;
      }
    },
    setSiblingsIdentityDocument(){
      if(this.studentParticular.siblingsIdentityDocument.isHas){
        this.studentParticular.siblingsIdentityDocument.siblings.map((v)=>{
           if(v.type == 0){
             v.certificateNo = v.certificateNoTop + v.certificateNoCont + v.certificateNoBottom;
           }
           return v
        })
      }
    },
    onSave() {
      this.setSiblingsIdentityDocument()
      this.setTypeOfIdentityDocument()
      this.setPlaceOfBirth()
      this.$emit("studentParticularSave");
    },
    onSaveAndContinue() {
      this.setSiblingsIdentityDocument()
      this.setTypeOfIdentityDocument()
      this.setPlaceOfBirth()
      this.$emit("studentParticularSaveAndContinue");
    },
    setPlaceOfBirth() {
      if (this.studentParticular.placeOfBirth == "其他 Others") {
        this.studentParticular.placeOfBirth =
          this.studentParticular.nationalityInput;
      }
      if (this.studentParticular.nationality == "其他 Others") {
        this.studentParticular.nationality =
          this.studentParticular.nationalityInput;
      }
       if (this.studentParticular.religion == "其他 Others") {
        this.studentParticular.religion =
          this.studentParticular.religionInput;
      }
      if (this.studentParticular.typeOfIdentityDocument.country == "其他 Others") {
        this.studentParticular.typeOfIdentityDocument.country = this.studentParticular.typeOfIdentityDocument.countryInput;
      }
    },
    changeIncorporatedManagementCommittees(){
      if(this.studentParticular.recommendedSchoolBoard.isHas== false){
        this.studentParticular.recommendedSchoolBoard.recommenderName=''
        this.studentParticular.recommendedSchoolBoard.recommenderContactMethod=''
        this.studentParticular.recommendedSchoolBoard.relationshipWithTheStudent=''
        this.studentParticular.recommendedSchoolBoard.recommenderLastAttendedClass=''
        this.studentParticular.recommendedSchoolBoard.recommenderStudentId=''
        this.studentParticular.recommendedSchoolBoard.recommenderGraduationYear=''
        this.studentParticular.recommendedSchoolBoard.relationshipWitheOurSchool=''
      }
    },
    changeRecommendedByOthers() {
     if(this.studentParticular.recommendedOthers.isHas==false){
        this.studentParticular.recommendedOthers.recommenderName=''
        this.studentParticular.recommendedOthers.recommenderContactMethod=''
        this.studentParticular.recommendedOthers.relationshipWithTheStudent=''
        this.studentParticular.recommendedOthers.recommenderLastAttendedClass=''
        this.studentParticular.recommendedOthers.recommenderStudentId=''
        this.studentParticular.recommendedOthers.recommenderGraduationYear=''
        this.studentParticular.recommendedOthers.relationshipWitheOurSchool=''
     }
    },
    changeChildOfAlumnus() {
      if(this.studentParticular.recommendedChildAlumnus.isHas==false){
        this.studentParticular.recommendedChildAlumnus.recommenderName=''
        this.studentParticular.recommendedChildAlumnus.recommenderContactMethod=''
        this.studentParticular.recommendedChildAlumnus.relationshipWithTheStudent=''
        this.studentParticular.recommendedChildAlumnus.recommenderLastAttendedClass=''
        this.studentParticular.recommendedChildAlumnus.recommenderStudentId=''
        this.studentParticular.recommendedChildAlumnus.recommenderGraduationYear=''
        this.studentParticular.recommendedChildAlumnus.relationshipWitheOurSchool=''
      }
    },
    changeCurrentStaff() {
      if (this.studentParticular.recommendedCurrentStaff.isHas == false) {
        this.studentParticular.recommendedCurrentStaff.recommenderName=''
        this.studentParticular.recommendedCurrentStaff.recommenderContactMethod=''
        this.studentParticular.recommendedCurrentStaff.relationshipWithTheStudent=''
        this.studentParticular.recommendedCurrentStaff.recommenderLastAttendedClass=''
        this.studentParticular.recommendedCurrentStaff.recommenderStudentId=''
        this.studentParticular.recommendedCurrentStaff.recommenderGraduationYear=''
        this.studentParticular.recommendedCurrentStaff.relationshipWitheOurSchool=''
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.document-identity-radio {
  display: flex;
  flex-direction: column;
}
.document-identity-radio .el-radio {
  display: flex;
  margin-bottom: 20px;
}
.el-button--primary {
  width: auto;
}
.logos-academy {
  margin-bottom: 20px;
}
.el-form-item__row,
.el-form-item__row-label {
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  box-sizing: border-box;
  vertical-align: middle;
  font-weight: 700;
}
.el-form-item__row::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.el-form-item__row-en::before{
   content: "";
}
.passport-row-label{
  width: fit-content;
  padding-right: 0.625rem;
}
::v-deep {
  .el-input__inner {
    border-color: #72acff;
  }
  .siblingsIdentityDocumentGender .el-radio-group{
    display: flex;
    align-items: center;
    align-content: center;
  }
  .siblingsIdentityDocumentGender .el-radio{
   margin-bottom: 0 !important;
  }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .passport-row {
    flex-direction: column;
  }
  .passport-row .el-col{
    margin-bottom: 0.625rem;
  }
  .form-item-primary-button .el-button{
    margin-bottom: 0.625rem;
  }
  .form-item-primary-button .el-button:last-child{
    margin-left: 0;
  }
  .siblingsIdentityDocumentGender .el-radio-group{
    display: flex;
    flex-direction: column;
  }
  .siblingsIdentityDocumentGender .el-radio{
   margin-bottom: 1.25rem !important;
  }
}
</style>